/* eslint-disable */
// THIS FILE IS AUTOGENERATED, SEE BACKEND TASK tools:apidoc:clientgen
// DISCLAIMER: this file does not actually CONTAIN enums but lookup tables generated FROM enums. Just don't have a better name for it ;_;

/** autogenerated value table mapping Components.Schemas.EntryAttachmentType */
export const EntryAttachmentType = {
  'performanceAssessmentEntry': 'performanceAssessmentEntry',
  'performanceAssessmentStudentEntry': 'performanceAssessmentStudentEntry',
  'note': 'note',
  'supportMeasureEntry': 'supportMeasureEntry',
  'supportMeasureProtocolEntry': 'supportMeasureProtocolEntry',
} as const;

/** autogenerated value table mapping Components.Schemas.AttachmentContentType */
export const AttachmentContentType = {
  'image': 'image',
  'file': 'file',
  'app': 'app',
} as const;

/** autogenerated value table mapping Components.Schemas.TemplateSetSource */
export const TemplateSetSource = {
  'digidoo': 'digidoo',
  'bmukk': 'bmukk',
  'custom': 'custom',
  'official': 'official',
} as const;

/** autogenerated value table mapping Components.Schemas.BillingMode */
export const BillingMode = {
  'perTenant': 'perTenant',
  'billedExternally': 'billedExternally',
} as const;

/** autogenerated value table mapping Components.Schemas.SchoolLevelLabelMode */
export const SchoolLevelLabelMode = {
  'adjusted': 'adjusted',
  'raw': 'raw',
} as const;

/** autogenerated value table mapping Components.Schemas.SchoolPublicOrPrivate */
export const SchoolPublicOrPrivate = {
  'private': 'private',
  'public': 'public',
  'unknown': 'unknown',
} as const;

/** autogenerated value table mapping Components.Schemas.GradeVisualizationType */
export const GradeVisualizationType = {
  'NUMERIC': 'NUMERIC',
} as const;

/** autogenerated value table mapping Components.Schemas.FilterOperationType */
export const FilterOperationType = {
  '=': '=',
  '<': '<',
  '<=': '<=',
  '>': '>',
  '>=': '>=',
  '!=': '!=',
  'like': 'like',
  'ilike': 'ilike',
  'contains': 'contains',
  'icontains': 'icontains',
  'search': 'search',
  'isearch': 'isearch',
  'startswith': 'startswith',
  'istartswith': 'istartswith',
  'endswith': 'endswith',
  'iendswith': 'iendswith',
  'eqstring': 'eqstring',
  'nestring': 'nestring',
  'in': 'in',
  'notin': 'notin',
  'instrings': 'instrings',
  'notinstrings': 'notinstrings',
  'eqnull': 'eqnull',
  'nenull': 'nenull',
  'array_contains': 'array_contains',
  'array_starts_with': 'array_starts_with',
  'array_ends_with': 'array_ends_with',
} as const;

/** autogenerated value table mapping Components.Schemas.ProviderTenantSortField */
export const ProviderTenantSortField = {
  'name': 'name',
  'country': 'country',
  'userCount': 'userCount',
  'schoolClassCount': 'schoolClassCount',
  'studentCount': 'studentCount',
  'billingMode': 'billingMode',
  'createdAt': 'createdAt',
  'isDisabled': 'isDisabled',
  'deactivatedAt': 'deactivatedAt',
} as const;

/** autogenerated value table mapping Components.Schemas.SortOrder */
export const SortOrder = {
  'asc': 'asc',
  'desc': 'desc',
} as const;

/** autogenerated value table mapping Components.Schemas.Product */
export const Product = {
  'school': 'school',
  'team': 'team',
  'proUser': 'proUser',
} as const;

/** autogenerated value table mapping Components.Schemas.SubscriptionState */
export const SubscriptionState = {
  'active': 'active',
  'trialing': 'trialing',
  'trialEnded': 'trialEnded',
  'cancelScheduled': 'cancelScheduled',
  'subscriptionOver': 'subscriptionOver',
} as const;

/** autogenerated value table mapping Components.Schemas.UserRoleType */
export const UserRoleType = {
  'owner': 'owner',
  'admin': 'admin',
  'user': 'user',
  'external': 'external',
} as const;

/** autogenerated value table mapping Components.Schemas.UserRoleStatus */
export const UserRoleStatus = {
  'active': 'active',
  'disabled': 'disabled',
  'invitationDeclined': 'invitationDeclined',
  'invitationPending': 'invitationPending',
} as const;

/** autogenerated value table mapping Components.Schemas.UserSource */
export const UserSource = {
  'GOOGLE_SEARCH': 'GOOGLE_SEARCH',
  'COLLEAGUE_REFERRAL': 'COLLEAGUE_REFERRAL',
  'SCHOOL_ADMIN': 'SCHOOL_ADMIN',
  'SOCIAL_MEDIA': 'SOCIAL_MEDIA',
  'EVENT_TRAINING': 'EVENT_TRAINING',
  'OTHER': 'OTHER',
} as const;

/** autogenerated value table mapping Components.Schemas.SubscriptionStatus */
export const SubscriptionStatus = {
  'active': 'active',
  'canceled': 'canceled',
  'incomplete': 'incomplete',
  'incomplete_expired': 'incomplete_expired',
  'past_due': 'past_due',
  'paused': 'paused',
  'trialing': 'trialing',
  'unpaid': 'unpaid',
} as const;

/** autogenerated value table mapping Components.Schemas.BillingInterval */
export const BillingInterval = {
  'year': 'year',
  'month': 'month',
} as const;

/** autogenerated value table mapping Components.Schemas.SchoolClassType */
export const SchoolClassType = {
  'class': 'class',
  'group': 'group',
} as const;

/** autogenerated value table mapping Components.Schemas.SchoolTermSemester */
export const SchoolTermSemester = {
  'first': 'first',
  'second': 'second',
} as const;

/** autogenerated value table mapping Components.Schemas.EntityAppearanceType */
export const EntityAppearanceType = {
  'text': 'text',
  'emoji': 'emoji',
  'icon': 'icon',
  'image': 'image',
} as const;

/** autogenerated value table mapping Components.Schemas.PerformanceAssessmentDocumentationMode */
export const PerformanceAssessmentDocumentationMode = {
  'COMPETENCE_ONLY': 'COMPETENCE_ONLY',
  'SCHOOL_GRADE': 'SCHOOL_GRADE',
  'VISUAL': 'VISUAL',
} as const;

/** autogenerated value table mapping Components.Schemas.EStudentNameMatch */
export const EStudentNameMatch = {
  'inClass': 'inClass',
  'existing': 'existing',
  'ambiguous': 'ambiguous',
  'new': 'new',
} as const;

/** autogenerated value table mapping Components.Schemas.NameRepresentation */
export const NameRepresentation = {
  'firstNameBeforeLastName': 'firstNameBeforeLastName',
  'lastNameBeforeFirstName': 'lastNameBeforeFirstName',
} as const;

/** autogenerated value table mapping Components.Schemas.NameSortation */
export const NameSortation = {
  'sortByFirstName': 'sortByFirstName',
  'sortByLastName': 'sortByLastName',
} as const;

/** autogenerated value table mapping Components.Schemas.WeekRepresentation */
export const WeekRepresentation = {
  'calendarWeek': 'calendarWeek',
  'schoolWeek': 'schoolWeek',
} as const;

/** autogenerated value table mapping Components.Schemas.ECompetenceTrendResolution */
export const ECompetenceTrendResolution = {
  'week': 'week',
  'month': 'month',
} as const;

/** autogenerated value table mapping Components.Schemas.ReportType */
export const ReportType = {
  'standard': 'standard',
  'notesReport': 'notesReport',
} as const;

/** autogenerated value table mapping Components.Schemas.CalculationMethod */
export const CalculationMethod = {
  'latestEntries': 'latestEntries',
  'allEntries': 'allEntries',
} as const;

/** autogenerated value table mapping Components.Schemas.ReportCoverSheet */
export const ReportCoverSheet = {
  'simple': 'simple',
  'withChart': 'withChart',
  'withCustomImage': 'withCustomImage',
  'withNote': 'withNote',
  'withFlower': 'withFlower',
} as const;

/** autogenerated value table mapping Components.Schemas.ReportCompetenceType */
export const ReportCompetenceType = {
  'compact': 'compact',
  'simple': 'simple',
  'withNotes': 'withNotes',
  'withPerformanceAssessments': 'withPerformanceAssessments',
} as const;

/** autogenerated value table mapping Components.Schemas.ReportSummarySheet */
export const ReportSummarySheet = {
  'simple': 'simple',
  'signature': 'signature',
} as const;

/** autogenerated value table mapping Components.Schemas.ReportStatus */
export const ReportStatus = {
  'inProgress': 'inProgress',
  'completed': 'completed',
} as const;

/** autogenerated value table mapping Components.Schemas.EPdfActionMode */
export const EPdfActionMode = {
  'print': 'print',
  'download': 'download',
} as const;

/** autogenerated value table mapping Components.Schemas.EReportDataStatus */
export const EReportDataStatus = {
  'reportable': 'reportable',
  'unratedOnly': 'unratedOnly',
  'noEntries': 'noEntries',
  'noStudentsInClass': 'noStudentsInClass',
  'noSubjectsInClass': 'noSubjectsInClass',
} as const;

/** autogenerated value table mapping Components.Schemas.ObservationTimelineEntryType */
export const ObservationTimelineEntryType = {
  'performanceAssessmentEntry': 'performanceAssessmentEntry',
  'note': 'note',
  'supportMeasureEntry': 'supportMeasureEntry',
} as const;

/** autogenerated value table mapping Components.Schemas.SupportMeasureProtocolEntryRating */
export const SupportMeasureProtocolEntryRating = {
  'positive': 'positive',
  'negative': 'negative',
} as const;

/** autogenerated value table mapping Components.Schemas.SupportMeasureActivityType */
export const SupportMeasureActivityType = {
  'studentAdded': 'studentAdded',
  'studentRemoved': 'studentRemoved',
  'studentEntriesRemoved': 'studentEntriesRemoved',
  'competenceAdded': 'competenceAdded',
  'competenceRemoved': 'competenceRemoved',
  'protocolEntryAdded': 'protocolEntryAdded',
  'protocolEntryRemoved': 'protocolEntryRemoved',
  'materialAdded': 'materialAdded',
  'materialRemoved': 'materialRemoved',
} as const;

/** autogenerated value table mapping Components.Schemas.ESupportMeasureReportCoverSheet */
export const ESupportMeasureReportCoverSheet = {
  'simple': 'simple',
  'plant': 'plant',
} as const;

/** autogenerated value table mapping Components.Schemas.ESupportMeasureReportSignatory */
export const ESupportMeasureReportSignatory = {
  'teacher': 'teacher',
  'parents': 'parents',
  'schoolAdministration': 'schoolAdministration',
} as const;

/** autogenerated value table mapping Components.Schemas.QueueJobCategory */
export const QueueJobCategory = {
  'active': 'active',
  'failed': 'failed',
} as const;

/** autogenerated value table mapping Components.Schemas.QueueJobStatus */
export const QueueJobStatus = {
  'queued': 'queued',
  'scheduled': 'scheduled',
  'running': 'running',
  'retrying': 'retrying',
  'failed': 'failed',
} as const;

/** autogenerated value table mapping Components.Schemas.QueuePriority */
export const QueuePriority = {
  'high': 'high',
  'normal': 'normal',
  'low': 'low',
} as const;

/** autogenerated value table mapping Components.Schemas.QueueExecutionOutcome */
export const QueueExecutionOutcome = {
  'completed': 'completed',
  'failed': 'failed',
  'cancelled': 'cancelled',
} as const;

/** autogenerated value table mapping Components.Schemas.CronJobStatus */
export const CronJobStatus = {
  'ok': 'ok',
  'failed': 'failed',
  'running': 'running',
  'never-run': 'never-run',
} as const;

/** autogenerated value table mapping Components.Schemas.ProviderUserSortField */
export const ProviderUserSortField = {
  'firstName': 'firstName',
  'lastName': 'lastName',
  'email': 'email',
  'createdAt': 'createdAt',
  'deactivatedAt': 'deactivatedAt',
  'isSetupCompleted': 'isSetupCompleted',
  'isApproved': 'isApproved',
  'competenceObservationsCount': 'competenceObservationsCount',
  'performanceAssessmentEntryCount': 'performanceAssessmentEntryCount',
  'performanceAssessmentStudentEntryCount': 'performanceAssessmentStudentEntryCount',
} as const;

/** autogenerated value table mapping Components.Schemas.ClickIdKey */
export const ClickIdKey = {
  'gclid': 'gclid',
  'gbraid': 'gbraid',
  'wbraid': 'wbraid',
  'fbclid': 'fbclid',
  'msclkid': 'msclkid',
  'ttclid': 'ttclid',
} as const;

/** autogenerated value table mapping Components.Schemas.ReleaseActionTarget */
export const ReleaseActionTarget = {
  'gradeCalculationSettings': 'gradeCalculationSettings',
} as const;

/** autogenerated value table mapping Components.Schemas.ReleaseContentType */
export const ReleaseContentType = {
  'title': 'title',
  'text': 'text',
  'bulletPoint': 'bulletPoint',
  'image': 'image',
} as const;

/** autogenerated value table mapping Components.Schemas.StatisticsRoleType */
export const StatisticsRoleType = {
  'all': 'all',
  'owner': 'owner',
  'admin': 'admin',
  'user': 'user',
  'external': 'external',
} as const;

/** autogenerated value table mapping Components.Schemas.EntryActivityResolution */
export const EntryActivityResolution = {
  'day': 'day',
  'week': 'week',
  'month': 'month',
} as const;

/** autogenerated value table mapping Components.Schemas.OnboardingCheckoutCompletionState */
export const OnboardingCheckoutCompletionState = {
  'provisioned': 'provisioned',
  'processing': 'processing',
  'paymentFailed': 'paymentFailed',
  'provisioningFailed': 'provisioningFailed',
} as const;

/** autogenerated value table mapping Components.Schemas.OnboardingCheckoutDraftStatus */
export const OnboardingCheckoutDraftStatus = {
  'pendingPayment': 'pendingPayment',
  'provisioned': 'provisioned',
  'provisioningFailed': 'provisioningFailed',
} as const;

/** autogenerated value table mapping Components.Schemas.OnboardingCheckoutDraftResolutionOutcome */
export const OnboardingCheckoutDraftResolutionOutcome = {
  'provisioned': 'provisioned',
  'notPaid': 'notPaid',
  'failed': 'failed',
  'discarded': 'discarded',
  'refused': 'refused',
} as const;

/** autogenerated value table mapping Components.Schemas.EReferralEventType */
export const EReferralEventType = {
  'REFERRAL_ACCEPTED': 'REFERRAL_ACCEPTED',
  'REFERRER_REWARDED': 'REFERRER_REWARDED',
  'REFERRED_TENANT_REGISTERED': 'REFERRED_TENANT_REGISTERED',
  'REFERRED_TENANT_SUBSCRIBED': 'REFERRED_TENANT_SUBSCRIBED',
  'DISCOUNT_REDEEMED': 'DISCOUNT_REDEEMED',
  'DISCOUNT_GRANTED': 'DISCOUNT_GRANTED',
} as const;

/** autogenerated value table mapping Components.Schemas.UserFeedbackCategory */
export const UserFeedbackCategory = {
  'starRating': 'starRating',
  'subscriptionTooExpensive': 'subscriptionTooExpensive',
  'missingFeatures': 'missingFeatures',
  'underUsed': 'underUsed',
  'preferFreeVersion': 'preferFreeVersion',
  'accountDeactivation': 'accountDeactivation',
} as const;

/** autogenerated value table mapping Components.Schemas.UserFeedbackEntity */
export const UserFeedbackEntity = {
  'performanceAssessmentEntry': 'performanceAssessmentEntry',
  'competenceEntry': 'competenceEntry',
  'report': 'report',
} as const;

/** autogenerated value table mapping Components.Schemas.FileMalwareScanStatus */
export const FileMalwareScanStatus = {
  'pending': 'pending',
  'clean': 'clean',
  'threatsFound': 'threatsFound',
  'unsupported': 'unsupported',
  'accessDenied': 'accessDenied',
  'failed': 'failed',
  'unavailable': 'unavailable',
  'legacy': 'legacy',
  'notRequired': 'notRequired',
} as const;

/** autogenerated value table mapping Components.Schemas.FileUploadType */
export const FileUploadType = {
  'userAvatar': 'userAvatar',
  'studentAvatar': 'studentAvatar',
  'tenantLogo': 'tenantLogo',
  'externalMaterialLogo': 'externalMaterialLogo',
  'performanceLevelPicture': 'performanceLevelPicture',
  'reportCoverImage': 'reportCoverImage',
  'releaseImage': 'releaseImage',
  'entityAppearanceImage': 'entityAppearanceImage',
  'entryAttachment': 'entryAttachment',
  'thumbnail': 'thumbnail',
} as const;

/** autogenerated value table mapping Components.Schemas.AsyncOperationStatus */
export const AsyncOperationStatus = {
  'queued': 'queued',
  'running': 'running',
  'failed': 'failed',
  'completed': 'completed',
  'cancelled': 'cancelled',
} as const;

/** autogenerated value table mapping Components.Schemas.ErrorTypes */
export const ErrorTypes = {
  'UNKNOWN': 'UNKNOWN',
  'NOT_IMPLEMENTED': 'NOT_IMPLEMENTED',
  'INVALID_TOKEN': 'INVALID_TOKEN',
  'INVALID_LOGIN': 'INVALID_LOGIN',
  'INVALID_PARAMETERS': 'INVALID_PARAMETERS',
  'TOO_MANY_REQUESTS': 'TOO_MANY_REQUESTS',
  'FILE_SIZE_LIMIT_EXCEEDED': 'FILE_SIZE_LIMIT_EXCEEDED',
  'FILE_TYPE_INVALID': 'FILE_TYPE_INVALID',
  'VALIDATION_FAILED': 'VALIDATION_FAILED',
  'FILE_VALIDATION_FAILED': 'FILE_VALIDATION_FAILED',
  'IMPORT_FAILED': 'IMPORT_FAILED',
  'EMPTY_DTO': 'EMPTY_DTO',
  'NO_PERMISSION': 'NO_PERMISSION',
  'FEATURE_DISABLED': 'FEATURE_DISABLED',
  'PERFORMANCE_ASSESSMENT_SUBJECT_ACCESS_DENIED': 'PERFORMANCE_ASSESSMENT_SUBJECT_ACCESS_DENIED',
  'COMPETENCE_ASSESSMENT_SUBJECT_ACCESS_DENIED': 'COMPETENCE_ASSESSMENT_SUBJECT_ACCESS_DENIED',
  'NOT_FOUND': 'NOT_FOUND',
  'INVALID_PASSWORD_RESET_CODE': 'INVALID_PASSWORD_RESET_CODE',
  'PASSWORD_RESET_MAIL_ALREADY_SENT': 'PASSWORD_RESET_MAIL_ALREADY_SENT',
  'USER_ALREADY_EXISTS': 'USER_ALREADY_EXISTS',
  'SCHOOL_YEAR_ALREADY_EXISTS': 'SCHOOL_YEAR_ALREADY_EXISTS',
  'SCHOOL_CLASS_ALREADY_ASSIGNED_TO_YEAR': 'SCHOOL_CLASS_ALREADY_ASSIGNED_TO_YEAR',
  'INVALID_SCHOOL_YEAR': 'INVALID_SCHOOL_YEAR',
  'UNKNOWN_REGISTRATION': 'UNKNOWN_REGISTRATION',
  'INVALID_IMPLICIT_DELETION': 'INVALID_IMPLICIT_DELETION',
  'INVALID_USER_INVITATION': 'INVALID_USER_INVITATION',
  'INVITATION_RECIPIENT_DEACTIVATED': 'INVITATION_RECIPIENT_DEACTIVATED',
  'TENANT_ALREADY_EXISTS': 'TENANT_ALREADY_EXISTS',
  'TEMPLATE_SET_ALREADY_EXISTS': 'TEMPLATE_SET_ALREADY_EXISTS',
  'TOO_MANY_LEVELS': 'TOO_MANY_LEVELS',
  'EMAIL_COOLDOWN_ACTIVE': 'EMAIL_COOLDOWN_ACTIVE',
  'INVALID_INVITATION_CODE': 'INVALID_INVITATION_CODE',
  'GET_FILE_ERROR': 'GET_FILE_ERROR',
  'FILE_ALREADY_EXISTS': 'FILE_ALREADY_EXISTS',
  'STUDENT_NO_SUBJECT_RELATION': 'STUDENT_NO_SUBJECT_RELATION',
  'EMAIL_CHANGE_MAIL_ALREADY_SENT': 'EMAIL_CHANGE_MAIL_ALREADY_SENT',
  'INVALID_EMAIL_CHANGE_CODE': 'INVALID_EMAIL_CHANGE_CODE',
  'PASSWORD_MISMATCH': 'PASSWORD_MISMATCH',
  'FOREIGN_KEY_CONSTRAINT': 'FOREIGN_KEY_CONSTRAINT',
  'CLASS_HAS_STILL_STUDENTS': 'CLASS_HAS_STILL_STUDENTS',
  'REPORT_ALREADY_COMPLETED': 'REPORT_ALREADY_COMPLETED',
  'REPORT_COVER_IMAGE_MISSING': 'REPORT_COVER_IMAGE_MISSING',
  'REPORT_NO_CLASS_ASSOCIATION': 'REPORT_NO_CLASS_ASSOCIATION',
  'TENANT_NOT_CONNECTED_TO_STATE': 'TENANT_NOT_CONNECTED_TO_STATE',
  'SCHOOL_YEAR_IN_USE': 'SCHOOL_YEAR_IN_USE',
  'CLASS_ALREADY_ARCHIVED': 'CLASS_ALREADY_ARCHIVED',
  'RELEASE_ID_ALREADY_EXISTS': 'RELEASE_ID_ALREADY_EXISTS',
  'PLAN_UPGRADE_REQUIRED': 'PLAN_UPGRADE_REQUIRED',
  'CONTACT_OWNER_TO_UPGRADE': 'CONTACT_OWNER_TO_UPGRADE',
  'MISSING_TENANT_ID': 'MISSING_TENANT_ID',
  'BILLING_PRODUCT_ALREADY_EXISTS': 'BILLING_PRODUCT_ALREADY_EXISTS',
  'BILLING_CHECKOUT_BLOCKED': 'BILLING_CHECKOUT_BLOCKED',
  'DEMO_CLASS_COPY_FAILED': 'DEMO_CLASS_COPY_FAILED',
  'PDFGEN_TIMEOUT_ERROR': 'PDFGEN_TIMEOUT_ERROR',
  'PDFGEN_FAILED_REQUEST': 'PDFGEN_FAILED_REQUEST',
  'PDFGEN_GENERIC_ERROR': 'PDFGEN_GENERIC_ERROR',
  'PDFGEN_FILE_SCAN_PENDING': 'PDFGEN_FILE_SCAN_PENDING',
  'PDFGEN_FILES_BLOCKED': 'PDFGEN_FILES_BLOCKED',
  'INVALID_REFERRAL_CODE': 'INVALID_REFERRAL_CODE',
  'REFERRAL_ALREADY_ATTRIBUTED': 'REFERRAL_ALREADY_ATTRIBUTED',
  'REFERRAL_GRANT_EXCEEDS_MAXIMUM': 'REFERRAL_GRANT_EXCEEDS_MAXIMUM',
  'REFERRAL_NOT_ELIGIBLE': 'REFERRAL_NOT_ELIGIBLE',
  'REFERRAL_SELF_REFERRAL': 'REFERRAL_SELF_REFERRAL',
  'WEEKLY_REPORT_FAILED': 'WEEKLY_REPORT_FAILED',
  'USER_DEACTIVATED': 'USER_DEACTIVATED',
  'LOCAL_AUTH_PROVIDER_NEEDED': 'LOCAL_AUTH_PROVIDER_NEEDED',
} as const;

/** autogenerated value table mapping Components.Schemas.EMailType */
export const EMailType = {
  'PasswordReset': 'PasswordReset',
  'NoLocalLoginInfo': 'NoLocalLoginInfo',
  'UserAlreadyExists': 'UserAlreadyExists',
  'SetPassword': 'SetPassword',
  'StartTrial': 'StartTrial',
  'UserInvitation': 'UserInvitation',
  'NonExistingUserInvitation': 'NonExistingUserInvitation',
  'UserAssignedToClass': 'UserAssignedToClass',
  'UserAssignedToGroup': 'UserAssignedToGroup',
  'EmailChangeRequest': 'EmailChangeRequest',
  'LoginVerification': 'LoginVerification',
  'TwoFactorReminder': 'TwoFactorReminder',
  'ReleaseNote': 'ReleaseNote',
  'UserApproved': 'UserApproved',
  'TransferOwnershipInvitation': 'TransferOwnershipInvitation',
  'TrialEnding': 'TrialEnding',
  'TrialEnded': 'TrialEnded',
  'BasePlanDowngrade': 'BasePlanDowngrade',
  'SubscriptionWelcome': 'SubscriptionWelcome',
  'TrialFirstEntryOverdue': 'TrialFirstEntryOverdue',
  'TrialCreateClassOverdue': 'TrialCreateClassOverdue',
  'TrialSchoolSetupOverdue': 'TrialSchoolSetupOverdue',
  'TrialFirstEntryDone': 'TrialFirstEntryDone',
  'TrialDecision': 'TrialDecision',
  'WeeklyReport': 'WeeklyReport',
  'TeamMemberDeactivated': 'TeamMemberDeactivated',
  'OnboardingReminder': 'OnboardingReminder',
  'OfferExpiring': 'OfferExpiring',
} as const;

/** autogenerated value table mapping Components.Schemas.EmailStatus */
export const EmailStatus = {
  'sending': 'sending',
  'success': 'success',
  'error': 'error',
} as const;

/** autogenerated value table mapping Components.Schemas.DeliveryState */
export const DeliveryState = {
  'delivered': 'delivered',
  'bounced': 'bounced',
  'complained': 'complained',
  'delayed': 'delayed',
  'rejected': 'rejected',
} as const;

/** autogenerated value table mapping Components.Schemas.EmailAuditMetadataKey */
export const EmailAuditMetadataKey = {
  'userId': 'userId',
  'targetUserId': 'targetUserId',
  'invitedById': 'invitedById',
  'targetClassId': 'targetClassId',
  'tenantId': 'tenantId',
  'billingSubscriptionId': 'billingSubscriptionId',
} as const;

/** autogenerated value table mapping Components.Schemas.AuthAttemptStatus */
export const AuthAttemptStatus = {
  'init': 'init',
  'tfaRequired': 'tfaRequired',
  'successForSameDevice': 'successForSameDevice',
  'successForAllDevices': 'successForAllDevices',
  'failed': 'failed',
  'used': 'used',
  'expired': 'expired',
} as const;

/** autogenerated value table mapping Components.Schemas.TfaOption */
export const TfaOption = {
  'totp': 'totp',
  'webauthn': 'webauthn',
  'email-otp': 'email-otp',
} as const;

/** autogenerated value table mapping Components.Schemas.GrowthPopupVariant */
export const GrowthPopupVariant = {
  'popups': 'popups',
  'checklist_only': 'checklist_only',
} as const;

/** autogenerated value table mapping Components.Schemas.TenantUserInvitationType */
export const TenantUserInvitationType = {
  'userInvitation': 'userInvitation',
  'transferOwnershipInvitation': 'transferOwnershipInvitation',
} as const;

/** autogenerated value table mapping Components.Schemas.NotificationType */
export const NotificationType = {
  'classInvite': 'classInvite',
  'welcome': 'welcome',
  'general': 'general',
  'reportSubjectEditRequest': 'reportSubjectEditRequest',
  'reportSubjectCompleted': 'reportSubjectCompleted',
  'newRelease': 'newRelease',
} as const;

/** autogenerated value table mapping Components.Schemas.NotificationChannel */
export const NotificationChannel = {
  'inApp': 'inApp',
  'email': 'email',
} as const;

/** autogenerated value table mapping Components.Schemas.CheckoutSource */
export const CheckoutSource = {
  'default': 'default',
  'trialUpsell': 'trialUpsell',
  'trialExpired': 'trialExpired',
  'trialWinback': 'trialWinback',
  'onboarding': 'onboarding',
} as const;

/** autogenerated value table mapping Components.Schemas.SeatType */
export const SeatType = {
  'student': 'student',
  'user': 'user',
} as const;

/** autogenerated value table mapping Components.Schemas.BillingOfferStatus */
export const BillingOfferStatus = {
  'pending': 'pending',
  'accepted': 'accepted',
  'expired': 'expired',
  'replaced': 'replaced',
  'deleted': 'deleted',
} as const;

/** autogenerated value table mapping Components.Schemas.BillingOfferAcceptanceMethod */
export const BillingOfferAcceptanceMethod = {
  'invoice': 'invoice',
  'online': 'online',
} as const;

/** autogenerated value table mapping Components.Schemas.BillingCollectionMethod */
export const BillingCollectionMethod = {
  'chargeAutomatically': 'chargeAutomatically',
  'sendInvoice': 'sendInvoice',
} as const;

/** autogenerated value table mapping Components.Schemas.ProductFeature */
export const ProductFeature = {
  'competenceDocumentation': 'competenceDocumentation',
  'statistic': 'statistic',
  'collaboration': 'collaboration',
  'report': 'report',
  'tenantCustomization': 'tenantCustomization',
  'accessRights': 'accessRights',
  'gradeCustomization': 'gradeCustomization',
  'supportMeasures': 'supportMeasures',
  'attachments': 'attachments',
} as const;

/** autogenerated value table mapping Components.Schemas.ProductOwnerType */
export const ProductOwnerType = {
  'tenant': 'tenant',
  'user': 'user',
} as const;

/** autogenerated value table mapping Components.Schemas.BillingPlanSwitchEffect */
export const BillingPlanSwitchEffect = {
  'noChange': 'noChange',
  'immediate': 'immediate',
  'periodEnd': 'periodEnd',
} as const;

/** autogenerated value table mapping Components.Schemas.GrowthPopupType */
export const GrowthPopupType = {
  'POPUP_FIRST_ENTRY': 'POPUP_FIRST_ENTRY',
  'POPUP_CREATE_CLASS': 'POPUP_CREATE_CLASS',
  'POPUP_SCHOOL_SETUP': 'POPUP_SCHOOL_SETUP',
  'NONE': 'NONE',
} as const;